/**
 * Feature opt-ins (Snooze / Scheduled send) — now HOLDER-WIDE (global across all
 * of the user's accounts), stored in the email settings blob rather than the
 * per-account `modules` record. Off by default.
 *
 * Read the current values via `useEmailUserSettings().features`; toggle them with
 * `useSetEmailFeatures()`.
 */

import { useEmailUserSettings, useSetEmailUserSettings } from './useEmailUserSettings';

export function useSetEmailFeatures() {
  const settings = useEmailUserSettings();
  const setAll = useSetEmailUserSettings();
  return {
    mutate: (patch: { snoozeEnabled?: boolean; scheduleEnabled?: boolean }) =>
      setAll.mutate({ ...settings, features: { ...settings.features, ...patch } }),
    isPending: setAll.isPending,
  };
}
